import { useState } from "react";
import { useAuth } from "../context/AuthContext";

export const useAuthForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passError, setPassError] = useState("");

  const { login, register, isAuthenticated } = useAuth();

  const resetErrors = () => {
    setEmailError("");
    setPassError("");
  };

  const handleError = (error) => {
    const errorMessage = error?.response?.data?.error;
    if (errorMessage === "User not found") {
      setEmailError(errorMessage);
    } else {
      setPassError(errorMessage || error.message || error);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    loading,
    setLoading,
    emailError,
    passError,
    resetErrors,
    handleError,
    isAuthenticated,
    login,
    register,
  };
};
